"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const parseStringToArray = value => {
  var _value$split;
  if (typeof value !== "string" || value === "") return value;
  return value === null || value === void 0 || (_value$split = value.split(",")) === null || _value$split === void 0 ? void 0 : _value$split.map(item => parseInt(item));
};
var _default = exports.default = parseStringToArray;